module.exports = __webpack_public_path__ + "img/gjng2921_1.e8a46f4a.svg";